import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { LinkTextPrimaryProps } from '../types/interfaces'

interface LinkTextPrimaryOptions {
  props: LinkTextPrimaryProps
}

interface LinkTextPrimaryReturn {
  refIsBlankTarget: ComputedRef<boolean>
}

export const useLinkTextPrimary = ({ props }: LinkTextPrimaryOptions): LinkTextPrimaryReturn => {
  const refIsBlankTarget = computed<boolean>(() => props.target === '_blank')

  return {
    refIsBlankTarget,
  }
}
